module.exports = __webpack_public_path__ + "assets/img/block-2e90d361.png";